// pages/NotFound.js
import React from 'react';
import './NotFound.css';
import logo from '../assets/LED-Speed-Signs-Logo.png';

const NotFound = () => {
  return (
    <div className="not-found">
      <img src={logo} alt="Logo" className="logo" />
      <h1>404 - Page Not Found</h1>
      <a href="/#/">Go Back to Home</a>
    </div>
  );
};

export default NotFound;
